import axios from "axios";
//import platform from "";
import { CurrencyIcon, UserType } from "./fixcode";
import secureLocalStorage from "react-secure-storage";
export const LocalStorage = {
  IsAuthorized:
    JSON.parse(sessionStorage.getItem("session_authorized")) === true,
  SessionId: sessionStorage.getItem("session_authtoken"),

  UserId: Number(sessionStorage.getItem("session_userid")),
  UserName: sessionStorage.getItem("session_username"),
  FirstName: sessionStorage.getItem("session_firstname"),
  LastName: sessionStorage.getItem("session_lastname"),
  Password: sessionStorage.getItem("session_password"),

  UserTypeId: Number(sessionStorage.getItem("session_usertypeid")),
  UserTypeName: sessionStorage.getItem("session_usertypename"),

  PhoneNumber: sessionStorage.getItem("session_mobile"),
  Email: sessionStorage.getItem("session_email"),
  ProfilePhotoUrl: sessionStorage.getItem("session_profilephotourl"),

  CustomerId: Number(sessionStorage.getItem("session_customerid")),
  BranchId: Number(sessionStorage.getItem("session_branchid")),
  BranchName: sessionStorage.getItem("session_branchname"),

  IsAdminUserLoggedIn:
    Number(sessionStorage.getItem("session_usertypeid")) ===
      UserType.SystemAdministrator ||
    Number(sessionStorage.getItem("session_usertypeid")) ===
      UserType.Administrator,
  IsSourcingManagerAdminLoggedIn:
    Number(sessionStorage.getItem("session_usertypeid")) ===
    UserType.SourcingManagerAdmin,
  CurrencyIcon: {
    Normal: sessionStorage.getItem("session_currencyicon"),
    Xs: `${sessionStorage.getItem("session_currencyicon")} fa-xs`,
    Sm: `${sessionStorage.getItem("session_currencyicon")} fa-sm`,
    Lg: `${sessionStorage.getItem("session_currencyicon")} fa-lg`,
  },
  Features: sessionStorage.getItem("session_features"),
  UserFeatureSetup: sessionStorage.getItem("session_userFeatureSetup"),
  get FeaturePermission() {
    return GetFeaturePermission();
  },
  AmeyoUserName: sessionStorage.getItem("session_ameyousername"),
  AmeyoPasscode: sessionStorage.getItem("session_ameyopasscode"),
  AmeyoAccess:
    sessionStorage.getItem("session_ameyoaccess") === "true" ? true : false,
  TrackingGuid: sessionStorage.getItem("session_trackingguid"),
};

export const SetSessionItem = (key, value) => {
  sessionStorage.removeItem(`session_${key}`);
  if (isNaN(value)) {
    sessionStorage.setItem(`session_${key}`, ToString(value));
  } else {
    sessionStorage.setItem(`session_${key}`, value);
  }
};

export const ClearSessionItems = () => {
  sessionStorage.clear();
};
function ToString(value) {
  try {
    return (value ?? "").trim();
  } catch (error) {
    console.log(error);
  }
  return "";
}

// Best-effort geo lookup. Capped so a slow/blocked third-party service never delays login;
// the API records the caller's IP itself when this returns empty.
export const getCurrentLocation = async (timeoutMs = 1500) => {
  try {
    const { data } = await axios.get("https://ipapi.co/json", {
      timeout: timeoutMs,
    });
    if (data)
      return {
        lat: data.latitude ?? 0,
        lng: data.longitude ?? 0,
        ip: data.ip ?? "",
      };
  } catch {
    // ignore — location is optional
  }
  return { lat: 0, lng: 0, ip: "" };
};

// Location captured at login; reused at logout so logout makes no external call.
export const getCachedLocation = () => {
  try {
    const geo = JSON.parse(sessionStorage.getItem("session_geo"));
    if (geo) return geo;
  } catch {}
  return { lat: 0, lng: 0, ip: "" };
};

export const getCurrencyIcon = (currencyCode) => {
  let currencyIcon = CurrencyIcon.ruppesFormat;
  if (currencyCode !== null) {
    switch (currencyCode.toLowerCase()) {
      case "inr":
        currencyIcon = CurrencyIcon.ruppesFormat;
        break;
      default:
        break;
    }
  }
  return currencyIcon;
};

export const GetFeatureAccess = (featureId) => {
  try {
    const setup = LocalStorage.UserFeatureSetup;
    if (!setup) return {};
    return JSON.parse(setup).find((item) => item.featureId === featureId) || {};
  } catch {
    return {};
  }
};

export const SetFeaturePermissionByPath = (path) => {
  return {
    ...JSON.parse(LocalStorage.Features).filter(
      (item) => item.requestPath === path,
    )[0],
  };
};

export const SetFeaturePermission = (feature) => {
  SetSessionItem("feature_permission", JSON.stringify(feature));
};
export const GetFeaturePermission = () => {
  let feature = null;
  try {
    // First try explicitly-stored permission (set via SetFeaturePermission)
    feature = JSON.parse(sessionStorage.getItem("session_feature_permission"));

    // Fall back to the current URL path. A page that is not a menu (detail / form pages such as
    // driver-boarding-view) takes the permission of its menu: the menu whose path its path starts
    // with, else the last menu page opened in this session.
    if (!feature) {
      const currentPath = window.location.pathname
        .replace(/^\//, "")
        .replace(/\/$/, "");
      const setup = JSON.parse(
        sessionStorage.getItem("session_userFeatureSetup") || "[]",
      );
      const pathOf = (item) =>
        (item.requestPath || "").replace(/^\//, "").replace(/\/$/, "");
      feature =
        setup.find((item) => pathOf(item) && pathOf(item) === currentPath) ||
        null;
      if (!feature) {
        feature =
          setup
            .filter(
              (item) =>
                pathOf(item) &&
                (currentPath.startsWith(`${pathOf(item)}-`) ||
                  currentPath.startsWith(`${pathOf(item)}/`)),
            )
            .sort((a, b) => pathOf(b).length - pathOf(a).length)[0] || null;
      }
      if (feature) {
        sessionStorage.setItem(
          "session_last_menu_feature",
          JSON.stringify(feature),
        );
      } else {
        feature =
          JSON.parse(sessionStorage.getItem("session_last_menu_feature")) ||
          null;
      }
    }
  } catch {}
  return {
    feature: feature,
    hasAccess: !!feature,
    roleId: feature?.roleId ?? null,
    featureId: feature?.featureId ?? null,
    displayName: feature?.displayName ?? "",
    requestPath: feature?.requestPath ?? "",
    allowAdd: feature?.allowAdd ?? false,
    allowEdit: feature?.allowEdit ?? false,
    allowView: feature?.allowView ?? false,
    allowDelete: feature?.allowDelete ?? false,
    allowPrint: feature?.allowPrint ?? false,
    allowExport: feature?.allowExport ?? false,
    allowApprove: feature?.allowApprove ?? false,
    allowSend: feature?.allowSend ?? false,
    allowSync: feature?.allowSync ?? false,
    allowUpload: feature?.allowUpload ?? false,
    allowNavigate: feature?.allowNavigate ?? false,
  };
};
export const SetPageTitle = (title) => {
  try {
    const el = document.querySelector("#lblPageTitle");
    if (el) {
      el.innerHTML = title;
    }
  } catch (error) {
    console.log(error);
  }
};
export const ClearAllHistoryState = () => {
  window.history.replaceState(null, "", window.location.href);
  //window.history.replaceState({}, "");
  //window.history.replaceState(null, null, "/");
};
export const ReplaceState = (state) => {
  window.history.replaceState(state, "", window.location.href);
};
